@if (hasFields) {
<div [ngClass]="containerClass">
    @if (isHeaderFields) {
    @for (flex of flexFields; track trackByFlexField($index, flex)) {
    <div [ngClass]="itemClass">
        <div class="text-500 font-medium mb-1">{{ getLabel(flex) }}</div>
        <div class="text-lg font-semibold">{{ formatValue(flex) }}</div>
    </div>
    }
    }
    @else {
    @for (flex of flexFields; track trackByFlexField($index, flex)) {
    <div [ngClass]="itemClass">
        <strong>{{ getLabel(flex) }}:</strong> {{ formatValue(flex) }}
    </div>
    }
    }
</div>
}